import React from 'react'

//Dependencies.
import { Col, Container, Row } from 'reactstrap';
import challengeWinner from "../../images/challengeWinner.png";
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

import "./DisplayWinner.styles.css";

const DisplayWinnerComponent = ({title, link, source, votes, ...rest}) => {
  return (
   <motion.div>
      <Container style={{backgroundColor: 'firebrick'}} className='py-3'>
         <Row>
            <Col style={{textAlign: 'center'}}>
               <h1 className="text-light">WINNER: <span style={{color: 'yellow'}}>{title}</span>!!!</h1>
               <Link to='/'><strong><h1 className='text-light'>BACK TO HOME PAGE.</h1></strong></Link>
            </Col>
         </Row>
         <div className='winnerDetails'>
            <img src={challengeWinner} className='img-fluid' alt='challege winner picture' />
         </div>
      </Container>  
   </motion.div>   
  )
}

export default DisplayWinnerComponent